<svg
  width="20"
  height="20"
  viewBox="0 0 20 20"
  fill="none"
  xmlns="http://www.w3.org/2000/svg"
>
  <path
    d="M9.99974 1.66663C6.32391 1.66663 3.33308 4.65746 3.33308 8.32913C3.30891 13.7 9.74641 18.1533 9.99974 18.3333C9.99974 18.3333 16.6906 13.7 16.6664 8.33329C16.6664 4.65746 13.6756 1.66663 9.99974 1.66663ZM9.99974 11.6666C8.15808 11.6666 6.66641 10.175 6.66641 8.33329C6.66641 6.49163 8.15808 4.99996 9.99974 4.99996C11.8414 4.99996 13.3331 6.49163 13.3331 8.33329C13.3331 10.175 11.8414 11.6666 9.99974 11.6666Z"
    fill="#262641"
    fill-opacity="0.64"
  />
</svg>
